import { render, staticRenderFns } from "./StyleComponent.vue?vue&type=template&id=f1d5fd90&"
import script from "./StyleComponent.vue?vue&type=script&lang=js&"
export * from "./StyleComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports